// Authentication hooks
// Convenience hooks for accessing auth state

import { useAuthContext } from './AuthContext';

/**
 * Main auth hook - returns all auth state and helpers
 */
export function useAuth() {
  const context = useAuthContext();
  return context;
}

/**
 * Hook to check if user is authenticated
 */
export function useIsAuthenticated(): boolean {
  const { isAuthenticated } = useAuthContext();
  return isAuthenticated;
}

/**
 * Hook to get current user
 */
export function useUser() {
  const { user } = useAuthContext();
  return user;
}

/**
 * Hook to get current organization
 */
export function useOrganization() {
  const { organization } = useAuthContext();
  return organization;
}

/**
 * Hook to check if current user is admin
 */
export function useIsAdmin(): boolean {
  const { isAdmin } = useAuthContext();
  return isAdmin;
}

/**
 * Hook to get organization ID
 */
export function useOrganizationId(): string | null {
  const { organizationId } = useAuthContext();
  return organizationId;
}

